import { Copy } from "lucide-react";
import { Button } from "@/view/components/ui/button";
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/view/components/ui/dialog";
import masks from "@/app/utils/masks";
import useAuthorizationLinkModal from "./useAuthorizationLinkModal";

interface AuthorizationLinkModalProps {
  onClose: () => void;
}

export default function AuthorizationLinkModal({
  onClose,
}: AuthorizationLinkModalProps) {
  const { authorization, handleCopyLink } = useAuthorizationLinkModal();

  return (
    <DialogContent className="sm:max-w-xl">
      <DialogHeader>
        <DialogTitle className="text-xl font-semibold text-black01">
          Link de autorização gerado com sucesso!
        </DialogTitle>
        <DialogDescription className="!mt-0 text-base text-black04">
          Você pode copiá-lo abaixo e acompanhar o status da autorização pela
          dashboard.
        </DialogDescription>
      </DialogHeader>

      <div className="w-full gap-4 rounded-[20px] bg-white p-[18px] shadow-md">
        <div className="my-1 flex items-center gap-1">
          <Copy
            className="cursor-pointer transition-opacity hover:opacity-70"
            size={18}
            onClick={handleCopyLink}
          />
          <p className="text-sm text-black01">{authorization.link}</p>
        </div>
        <p className="text-sm text-error">
          Expira em: {masks.date(authorization.expirationDate)}
        </p>
      </div>

      <Button
        className="mt-2 rounded-full font-semibold text-white"
        onClick={onClose}
      >
        Ver autorização
      </Button>
    </DialogContent>
  );
}
